import { render, staticRenderFns } from "./add-update-fee-sheets.vue?vue&type=template&id=b943908c&scoped=true&"
import script from "./add-update-fee-sheets.vue?vue&type=script&lang=ts&"
export * from "./add-update-fee-sheets.vue?vue&type=script&lang=ts&"
import style0 from "./add-update-fee-sheets.vue?vue&type=style&index=0&id=b943908c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b943908c",
  null
  
)

export default component.exports